function formatPrice(cents) {
  try {
    const currency = window.Shopify?.currency?.active || 'EUR';
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency }).format(cents / 100);
  } catch (error) {
    return '€' + (cents / 100).toFixed(2);
  }
}

async function fetchProduct(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) return null;
    return await response.json();
  } catch (error) {
    return null;
  }
}

function renderCard(product) {
  const image = product.featured_image || (product.images && product.images[0]) || '';
  const price = formatPrice(product.price);
  const safeTitle = product.title.replace(/"/g, '&quot;');

  const card = document.createElement('div');
  card.className = 'wishlist-page__card-wrapper';
  card.innerHTML = `
    <a href="/products/${product.handle}" class="wishlist-page__card">
      <div class="wishlist-page__card-image-wrapper">
        ${image ? `<img class="wishlist-page__card-image" src="${image}" alt="${safeTitle}" loading="lazy">` : ''}
      </div>
      <div class="wishlist-page__card-title">${product.title}</div>
      <div class="wishlist-page__card-price">${price}</div>
    </a>
    <button
      type="button"
      class="wishlist-page__card-remove"
      data-wishlist-remove="${product.handle}"
      aria-label="Verwijder uit favorieten"
    >
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 20.5s-7.2-4.5-9.8-8.7C.6 8.9 1.4 5.4 4.6 4c2.3-1 4.8 0 7.4 2.9C14.6 4 17.1 3 19.4 4c3.2 1.4 4 4.9 2.4 7.8-2.6 4.2-9.8 8.7-9.8 8.7z"
          fill="currentColor"
        />
      </svg>
    </button>
  `;
  return card;
}

async function init() {
  const loadingEl = document.querySelector('[data-wishlist-loading]');
  const gridEl = document.querySelector('[data-wishlist-grid]');
  const emptyEl = document.querySelector('[data-wishlist-empty]');
  const subtitleEl = document.querySelector('[data-wishlist-page-subtitle]');

  if (!gridEl) return;

  const handles = window.ClubTradeWishlist
    ? window.ClubTradeWishlist.getWishlist()
    : JSON.parse(localStorage.getItem('clubdepot_wishlist') || '[]');

  if (!handles.length) {
    if (loadingEl) loadingEl.hidden = true;
    if (emptyEl) emptyEl.hidden = false;
    return;
  }

  const products = (await Promise.all(handles.map(fetchProduct))).filter(Boolean);

  if (loadingEl) loadingEl.hidden = true;

  if (!products.length) {
    if (emptyEl) emptyEl.hidden = false;
    return;
  }

  if (subtitleEl) {
    subtitleEl.textContent = `${products.length} ${products.length === 1 ? 'club' : 'clubs'} opgeslagen`;
  }

  gridEl.hidden = false;
  products.forEach((product) => {
    gridEl.appendChild(renderCard(product));
  });

  gridEl.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-remove]');
    if (!button) return;
    event.preventDefault();
    const handle = button.getAttribute('data-wishlist-remove');
    if (window.ClubTradeWishlist) {
      window.ClubTradeWishlist.toggleWishlist(handle);
    }
    const wrapper = button.closest('.wishlist-page__card-wrapper');
    wrapper?.remove();
    if (!gridEl.children.length) {
      gridEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
